const norm = (s) => (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function searchAll(site, q) {
  const t = norm(q).trim();
  if (t.length < 2) return [];
  const d = site.data;
  const hit = (...f) => f.some((x) => norm(Array.isArray(x) ? x.join(" ") : x).includes(t));
  const out = [];
  d.activities.forEach((a) => hit(a.title, a.summary, a.description, site.cats[a.category_id]?.name, site.placeOf(a)) && out.push({ type: "Atividade", title: a.title, to: `/atividade/${a.slug}`, id: a.id }));
  d.organizations.forEach((o) => hit(o.name, o.area, o.description) && out.push({ type: "Organização", title: o.name, to: `/organizacoes/${o.slug}`, id: o.id }));
  d.spaces.forEach((s) => hit(s.name, s.description) && out.push({ type: "Local", title: s.name, to: `/mapa?espaco=${s.slug}`, id: s.id }));
  d.events.forEach((e) => hit(e.title, e.summary) && out.push({ type: "Semana", title: e.title, to: `/semana/${e.slug}`, id: e.id }));
  d.news.forEach((n) => hit(n.title, n.excerpt, n.body) && out.push({ type: "Notícia", title: n.title, to: `/noticias/${n.slug}`, id: n.id }));
  d.resources.forEach((r) => hit(r.title, r.body) && out.push({ type: "Saúde Mental", title: r.title, to: `/saude-mental#${r.slug}`, id: r.id }));
  d.pages.forEach((p) => hit(p.title, p.body) && out.push({ type: "Informação", title: p.title, to: p.group === "info" ? `/informacoes#${p.slug}` : `/${p.slug === "a-feira" ? "" : p.slug}`, id: p.id }));
  return out;
}
